import { render, staticRenderFns } from "./EyeCare.vue?vue&type=template&id=4b02738d&scoped=true"
import script from "./EyeCare.vue?vue&type=script&lang=js"
export * from "./EyeCare.vue?vue&type=script&lang=js"
import style0 from "./EyeCare.vue?vue&type=style&index=0&id=4b02738d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b02738d",
  null
  
)

export default component.exports